import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import { Lightbox } from './Lightbox.jsx';

// ─── SOP Viewer Modal ─────────────────────────────────────────────────────────
export function SOPModal({ sopId, onClose }) {
  const [sop, setSop] = useState(null);
  const [checked, setChecked] = useState({});
  const [lightboxSrc, setLightboxSrc] = useState(null);

  useEffect(() => { api('GET', `/api/sop/${sopId}`).then(setSop); }, [sopId]);

  function toggle(id) { setChecked(c => ({ ...c, [id]: !c[id] })); }
  const allDone = sop && sop.steps.every(s => checked[s.id]);

  return (
    <>
      {lightboxSrc && <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />}
      <div className="fixed inset-0 bg-black/60 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose}>
        <div className="bg-white w-full sm:max-w-lg rounded-t-2xl sm:rounded-2xl max-h-[85vh] flex flex-col fade-in shadow-2xl"
          onClick={e => e.stopPropagation()}>
          <div className="bg-ink rounded-t-2xl p-5 flex items-start justify-between flex-shrink-0">
            <div>
              <p className="text-gold text-xs uppercase tracking-widest mb-1">Standard Operating Procedure</p>
              <h3 className="text-cream font-bold text-lg leading-tight">{sop?.title}</h3>
            </div>
            <div className="flex items-center gap-2 ml-4">
              <button onClick={onClose} className="text-cream/50 hover:text-cream text-3xl leading-none">×</button>
            </div>
          </div>
          {sop ? (
            <div className="overflow-y-auto flex-1 p-5 sop-content">
              <p className="text-sm text-gray-500 mb-4 font-medium">{sop.steps.length} steps · Check each step as you go</p>
              <div className="space-y-2">
                {sop.steps.map(step => (
                  <div key={step.id} className={`sop-step rounded-xl border transition-all overflow-hidden ${checked[step.id] ? 'border-green-200 bg-green-50' : 'border-gray-200 bg-white hover:border-gray-300'}`}>
                    <div className="flex items-start gap-3 p-4 cursor-pointer" onClick={() => toggle(step.id)}>
                      <div className={`w-7 h-7 rounded-full flex-shrink-0 flex items-center justify-center text-sm font-bold transition-all mt-0.5 ${checked[step.id] ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-600'}`}>
                        {checked[step.id] ? '✓' : step.step_number}
                      </div>
                      <p className={`text-sm leading-relaxed flex-1 pt-0.5 font-medium ${checked[step.id] ? 'sop-step-done' : 'sop-step-text'}`}>
                        {step.description}
                      </p>
                    </div>
                    {step.image_url && (
                      <div className="px-4 pb-3 pl-14">
                        <img src={step.image_url} alt="Step reference"
                          className="w-24 h-16 object-cover rounded-lg border border-gray-200 cursor-pointer hover:opacity-90 hover:border-gray-400 transition-all shadow-sm"
                          onClick={e => { e.stopPropagation(); setLightboxSrc(step.image_url); }} />
                        <p className="text-xs text-gray-400 mt-1">Tap to enlarge</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              {allDone && (
                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-xl text-center">
                  <p className="text-green-700 font-semibold text-sm">All steps complete! ✓</p>
                </div>
              )}
            </div>
          ) : (
            <div className="p-10 text-center text-gray-400">Loading...</div>
          )}
        </div>
      </div>
    </>
  );
}
